module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"targetsTitle":"Ziele","yearTitle":"Jahr","s12eTargetTitle":"Ziel Scope 1-2 Emissionen","s123eTargetTitle":"Ziel Scope 1-3 Emissionen","eeTargetTitle":"Ziel Endenergie","peTargetTitle":"Ziel Primärenergie","noTargets":"Dieses Portfolio enthält keine Ziele","addTargetButton":"Ziel hinzufügen"}}')
  delete Component.options._Ctor
}
